import React, { PropTypes, Component } from 'react';
import { v4 } from 'node-uuid';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import ConfirmModal from 'common/components/modal/confirmation_dialog';
import ReputationChart from 'common/components/reputation_chart';
import ReputationTag from 'common/components/reputation_tag';
import Avatar from 'common/components/avatar';

const EmptyResults = () => (
  <div className="small-16 column">
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>No removed creatives</h3>
      </div>
    </div>
  </div>
);

export const RemovedTableRow = ({
  id, avatar, first_name, last_name, username, reputation,
  is_elite, is_platinum, reinstate
}) => {
  const onReinstate = partial(reinstate, { id, username });
  const reputationInt = parseInt(reputation, 10);

  return (<tr>
    <td>
      <Link to={`/users/${username}/`} target="_blank">
        <Avatar user={{ avatar, first_name, last_name, username }}
          extraClasses="avatar-sm avatar-inline show-for-medium"/> {' '}
        <span className="hide-for-small-only">{username}</span>
        <span className="show-for-small-only">{truncate(username, { length: 20 })}</span>
      </Link>
    </td>
    <td>
      <ReputationChart className="stat-chart" reputation={reputationInt} chartClass="small"/>
      <ReputationTag extraClasses="hide-for-small-only" user={{ is_elite, is_platinum }} />
    </td>
    <td className="action">
      <button onClick={onReinstate} className="btn btn-text btn-md">Reinstate</button>
    </td>
  </tr>);
};

class RemovedTable extends Component {
  constructor(props) {
    super(props);
    this.state = { modalUser: null };
    this.setModal = this.setModal.bind(this);
  }

  setModal(user) {
    this.setState({ modalUser: user });
  }

  render() {
    const { removed, reinstate } = this.props;
    if (!removed.length) {
      return (<EmptyResults />);
    }

    const user = this.state.modalUser;
    const closeModal = partial(this.setModal, null);

    return (<div className="small-16 column">
      <table className="table table-default access removed">
        <thead>
          <tr>
            <td>user</td>
            <td>reputation</td>
            <td />
          </tr>
        </thead>
        <tbody>
          { removed.map(removedUser => (
            <RemovedTableRow key={v4()} {...removedUser} reinstate={this.setModal} />
          )) }
        </tbody>
      </table>
      {user && <ConfirmModal
        dialogVisible={this.state.modalUser !== null}
        dialogHeader={`Are you sure you want to reinstate ${user.username}?`}
        dialogMessage={`If you reinstate them, ${user.username} will be able to participate in this project, however their previous entries will remain eliminated.`}
        toggleDialog={closeModal}
        submitAction={() => reinstate(user.id).then(closeModal)}
      />}
    </div>);
  }
}

RemovedTableRow.propTypes = {
  id: PropTypes.number.isRequired,
  username: PropTypes.string.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  reputation: PropTypes.number.isRequired,
  is_elite: PropTypes.bool.isRequired,
  is_platinum: PropTypes.bool.isRequired,
  reinstate: PropTypes.func.isRequired,
};

RemovedTable.propTypes = {
  removed: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    reputation: PropTypes.number.isRequired,
    is_elite: PropTypes.bool.isRequired,
    is_platinum: PropTypes.bool.isRequired,
  })).isRequired,
  reinstate: PropTypes.func.isRequired,
};

export default RemovedTable;



// WEBPACK FOOTER //
// ./project/components/removed.jsx